import { render, staticRenderFns } from "./WalkingCustomer.vue?vue&type=template&id=3b3f6fd4&scoped=true&"
import script from "./WalkingCustomer.vue?vue&type=script&lang=js&"
export * from "./WalkingCustomer.vue?vue&type=script&lang=js&"
import style0 from "./WalkingCustomer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WalkingCustomer.vue?vue&type=style&index=1&id=3b3f6fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3f6fd4",
  null
  
)

export default component.exports